<template>
    <div class="rounded-md  border-[#cccccc] py-1 px-2 border text-sm outline-[#016B00] text-[#24723b]  bg-[#fff] relative">
        <p class="text-xs text-[#949494]">{{ labelname }}</p>
        <select class=" outline-none text-[#12760A] text-sm font-semibold  w-full" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)">
            <option v-for="(row, index) in data" :key="index" :value="row.key" class="text-[#12760A] text-left">{{ row.value }}</option>
        </select> 
    </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    data(){
        return{
            selected: null,
        }
    },
    props:{
        data:{
            type: Array,
            default:()=>[
                { key: "ALL", value: "ALL" },
                { key: "TEST1", value: "TEST1" }
            ]
        },
        labelname:{
            type: String,
            default: "BUTTON NAME"
        },
        modelValue: {
            type: String,
            default: ''
        },
    }
})
</script>

